import { useLang } from "@/i18n";
import Reveal from "./Reveal";

const stats = [
  { value: "02", labelKey: "stats_countries", display: "TM & UZ" },
  { value: "2018", labelKey: "stats_categories", display: "2018" },
  { value: "03", labelKey: "stats_modes" },
  { value: "04", labelKey: "stats_partners" },
];

export default function Manifesto() {
  const { t } = useLang();
  const chapters = [
    { n: "01", t: t("ch1_t"), d: t("ch1_d") },
    { n: "02", t: t("ch2_t"), d: t("ch2_d") },
    { n: "03", t: t("ch3_t"), d: t("ch3_d") },
  ];

  return (
    <section id="values" data-testid="manifesto" className="relative bg-[#ffffff] py-24 md:py-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d81f2a]">
            {t("manifesto_overline")}
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-4xl font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-[0.95] tracking-tight text-[#0f1115]">
            {t("manifesto_title")}
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 border-t border-l border-black/10">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="group border-r border-b border-black/10 p-8 md:p-10 h-full hover:bg-[#ffffff] transition-colors">
                <span className="font-display text-6xl md:text-7xl font-extrabold text-[#0f1115]/10 group-hover:text-[#d81f2a] transition-colors">
                  {c.n}
                </span>
                <h3 className="mt-6 font-display text-2xl font-bold uppercase tracking-tight text-[#0f1115]">
                  {c.t}
                </h3>
                <p className="mt-4 font-body text-sm text-[#5b6472] leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="bg-[#ffffff] p-8">
                <div className="font-display text-4xl md:text-5xl font-extrabold text-[#d81f2a]">
                  {s.display || s.value}
                </div>
                <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5b6472]">
                  {t(s.labelKey)}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
